/** Rounds a split cost to currency scale so the payload matches the 2dp value the drawer shows. */
const roundSplitCost = (value: number): number => Math.round(value * 100) / 100;

/** Splits a cost by percentage; the second leg takes the remainder so the legs re-sum to the total. */
export const splitCostByPercentage = (total: number, percentage: number): [number, number] => {
	const first = roundSplitCost((total * percentage) / 100);

	return [first, roundSplitCost(total - first)];
};
